
<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

  <!--<div class = "row">
         <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" >
            <div class="col-12 text-center">
                <p style="font-size:18px; color:#9b7544">
                    <strong >Services with fees</strong>
                </p>
            </div>
            <div *ngIf="finalfees && services">
            <div  *ngFor="let menu of finalfees" >
                <div>
                        <div *ngFor="let s of services">
                            <div class="row">
                                    <div class="col text-center" *ngIf="menu.service_id == s.id" > {{s.name}}</div>
                                    <div class="col text-center" *ngIf="menu.service_id == s.id"> Rs. {{menu.fees}}   </div>
                            </div>
                        </div>
                </div>
                </div>
            </div>
         </div>
            </div>-->

            <div *ngIf="servicemenus && servicemenus.length > 0">
                <div>
 
                   <h1 style="color:#9b7544;"> Services </h1>
                </div> <br>
                 <span *ngFor = 'let s of services'>
                 <span *ngFor = 'let sp of finalfees'>
 
                       <span style="    background-color: #dbd3be;  padding: 10px; border-radius: 10px; margin: 0 5px 0 0; line-height: 45px" *ngIf='s.id === sp.service_id'>
                          {{s.name}}
                       </span>
 
 
                     </span>
                   </span>
 
         </div>